// extracted by mini-css-extract-plugin
export default {"input":"TextBox-module__input--bWKgR"};